import { Plugin, PluginKey, TextSelection } from 'prosemirror-state';
import {getImagePathSvg, getImagePathWithThemeSvg, imgPathPerfix} from "../../../utils";
import ListItem from '@tiptap/extension-list-item'
import { Extension, markPasteRule, mergeAttributes } from '@tiptap/core'

export const getListItemExtend = (from:any)=>{
    return ListItem.extend({
        addAttributes() {
            return {
                id: {
                    default: () =>null, // 默认生成唯一ID
                    // parseHTML: element => {
                    //   return element?.getAttribute('id') || crypto.randomUUID();
                    // },
                    // renderHTML: attributes => {
                    //   console.log(22,attributes);
                    // },
                },
                listFold: {
                    default: false,
                    renderHTML: attributes => {
                        if (attributes.listFold === undefined) {
                            return {};
                        }
                        return {
                            'data-listFold': attributes.listFold,
                        };
                    },
                },
                // ifhidden: {
                //   default: false,
                //   renderHTML: attributes => {
                //     if (attributes.ifhidden === undefined) {
                //       return {};
                //     }
                //     return {
                //       'ifhidden': attributes.ifhidden,
                //     };
                //   },
                // }
            }
        },
        renderHTML({ node, HTMLAttributes }) {
            const listFold = node.attrs.listFold || false; // 获取 fold 属性，默认为 false
            const checked = node.attrs.checked || undefined;
            const getSrc = ()=>{
                if (from == 'stickynote'){
                    return listFold ? getImagePathSvg("arrowRight") : getImagePathSvg("arrowBottom")
                }
                return listFold ? getImagePathWithThemeSvg("arrowRight") : getImagePathWithThemeSvg("arrowBottom")
            }
            return [
                'li',
                mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
                    'data-type': this.name,
                    class: 'list-container',
                    'id': node.attrs.id,
                }),
                [
                    'img', // 使用 img 元素
                    {
                        class: 'list-image', // 添加自定义样式类
                        src: getSrc(), // 设置 src 属性
                    }
                ],
                ['span', 0],
            ]
        },
        parseHTML() {
            return [
                {
                    tag: `li[data-type="${this.name}"]`,
                    priority: 51,
                    getAttrs: element => {
                        // 必须显式解析属性
                        const listFold = element.getAttribute('data-listFold') === 'true';
                        const id = element.getAttribute('id');

                        // 检查并转换 data-checked
                        const dataCheckedAttr = element.getAttribute('data-checked');
                        const checked = dataCheckedAttr === 'true' ? true
                            : dataCheckedAttr === 'false' ? false
                                : undefined; // 可选：没有该属性时设为 undefined
                        return {
                            listFold,
                            id,
                            // ...(checked !== undefined ? { checked } : {})
                        };
                    },
                },
                {
                    tag: `li`,
                    priority: 50,
                    getAttrs: element => {
                        // 必须显式解析属性
                        const listFold = element.getAttribute('data-listFold') === 'true';
                        const id = element.getAttribute('id');

                        // 检查并转换 data-checked
                        const dataCheckedAttr = element.getAttribute('data-checked');
                        const checked = dataCheckedAttr === 'true' ? true
                            : dataCheckedAttr === 'false' ? false
                                : undefined; // 可选：没有该属性时设为 undefined
                        return {
                            listFold,
                            id,
                            // ...(checked !== undefined ? { checked } : {})
                        };
                    },
                },
            ]
        },
        addProseMirrorPlugins() {
            return [
                new Plugin({
                    key: new PluginKey("listItemIdPlugin"),
                    appendTransaction: (transactions, oldState, newState) => {
                        // 只处理有实际变更的事务
                        if (!transactions.some(tr => tr.docChanged)) return null;

                        let tr = newState.tr;
                        let modified = false;

                        // 记录所有已使用的ID
                        const usedIds = new Set();

                        newState.doc.descendants((node, pos) => {
                            if (node.type.name === "listItem") {
                                if (!node.attrs.id) {
                                    // 节点没有ID，分配一个新ID
                                    const newId = crypto.randomUUID();
                                    tr = tr.setNodeMarkup(pos, undefined, {
                                        ...node.attrs,
                                        id: newId,
                                    });
                                    usedIds.add(newId);
                                    modified = true;
                                    // console.log("分配新ID:", newId, "给位置:", pos);
                                } else if (usedIds.has(node.attrs.id)) {
                                    // ID已经被使用，需要重新分配
                                    const newId = crypto.randomUUID();
                                    tr = tr.setNodeMarkup(pos, undefined, {
                                        ...node.attrs,
                                        id: newId,
                                    });
                                    usedIds.add(newId);
                                    modified = true;
                                    // console.log("重新分配ID:", node.attrs.id, "->", newId, "给位置:", pos);
                                } else {
                                    // 记录当前ID为已使用
                                    usedIds.add(node.attrs.id);
                                }
                            }
                        })
                        return modified ? tr : null;
                    }
                }),
                new Plugin({
                    props: {
                        handleDOMEvents: {
                            click: (view, event) => {
                                const target = event.target;
                                if (target.tagName === 'IMG' && target.classList.contains('list-image')) {
                                    const targetId = target.parentNode.getAttribute('id')
                                    const targetNodeNP = this.editor.$doc.querySelectorAll('listItem', { id: targetId })[0]
                                    const { from, to } = this.editor.state.selection;
                                    const { state, dispatch } = this.editor.view;
                                    const { tr } = state;
                                    const { schema } = state;
                                    setTimeout(() => {
                                        // 改变所属节点的隐藏显示状态
                                        targetNodeNP.children.forEach(ele => {
                                            if (ele.node.type.name === 'taskList' || ele.node.type.name === 'bulletList' || ele.node.type.name === 'orderedList') {
                                                tr.setNodeMarkup(ele.pos - 1, schema.nodes[`${ele.node.type.name}`], {
                                                    ...ele.node.attrs,
                                                    ifhidden: !targetNodeNP.node.attrs.listFold ? true : false
                                                });
                                            }
                                        })
                                        // 修改当前节点的listfold
                                        tr.setNodeMarkup(
                                            targetNodeNP.pos - 1,
                                            schema.nodes[`${targetNodeNP.node.type.name}`],
                                            {
                                                ...targetNodeNP.node.attrs,
                                                listFold: !targetNodeNP.node.attrs.listFold,
                                            }
                                        );
                                        const targetParagraphNodeNP =
                                            this.editor.$doc.querySelectorAll("paragraph", {
                                                id: targetNodeNP?.content?.content?.[0].attrs.id,
                                            })[0];
                                        if (
                                            !targetNodeNP.node.attrs.listFold &&
                                            from === to &&
                                            to < targetNodeNP.to &&
                                            from > targetParagraphNodeNP.to
                                        ) {
                                            tr.setSelection(
                                                TextSelection.create(
                                                    tr.doc,
                                                    targetParagraphNodeNP.to - 1
                                                )
                                            );
                                        }
                                        dispatch(tr);
                                    }, 50);
                                }
                            },
                        },
                    },
                }),
            ];
        },
    })
}